export const SET_MEMBERSHIP_PRICE_ID = 'SET_MEMBERSHIP_PRICE_ID';
export const SET_PAYMENT_METHOD_ID = 'SET_PAYMENT_METHOD_ID';

export const SET_SELECTED_PAY_MODE = 'SET_SELECTED_PAY_MODE';

export const SET_DISCOUNT_CODE = 'SET_DISCOUNT_CODE';